$(function () {
    Storage.prototype.setObj = function (key, obj) {
        return this.setItem(key, JSON.stringify(obj))
    };
    Storage.prototype.getObj = function (key) {
        return JSON.parse(this.getItem(key))
    };

    setTimeout(function(){
      $(".coattend-button").on("click",function(){
        console.log("coatten-button");
        $("#latte-art #coattend-iframe").contents().find(".layer").remove();  
      });
    },2000)
    $(".btn--add-to-cart").on("click", function (e) {
      console.log("btn add to cart");
        let nb = 0;
        if ($(".extra-p").length > 0) {
          console.log("extra-p");
            const gift_product = $(".extra-p").val()
          console.log("-> gift_product", gift_product);
          const storage = localStorage.getItem('storedItems')
          const storedItems = JSON.parse(storage)
            let savedItem = false;
            if (storedItems) {
                const isFound = storedItems.find(item => item.storedDiscount === $(".extra-p-code").val());
                if (isFound) {
                    savedItem = true;
                }
                
            }
            console.log("savedItem:"+savedItem);
            if (savedItem) {
                return false
            }
            const gift_product_code = $(".extra-p-code").val()
          console.log("gift_product_code:"+gift_product_code);
            
            $.getJSON('/cart.js', function (cart) {
                console.log(cart.items);
                cart.items.forEach(function (value, key) {
                     console.log(value.variant_id)
                     console.log(Number(gift_product))
                    if (value.variant_id === Number(gift_product)) {
                        nb = 1;
                        // console.log('nb = 1');
                    }
                })
            });
            setTimeout(function () {
                console.log("Free Item add setTimeOut")
              console.log("-> nb", nb);
               
                    let data = {
                        quantity: 1,
                        id: $(".extra-p").val()
                    }
                    
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        dataType: 'json',
                        data: data,
                        success: function (response) {
                            console.log('Free Item added to cart');
                            const storedItems = localStorage.getItem('storedItems');
                            const newItem = {
                                storedFreeItem: $(".extra-p").val(),
                                storedDiscount: $(".extra-p-code").val(),
                                relatedProduct : $('input[data-productid]').val()

                            };

                            if (storedItems) {
                                const parsedItems = JSON.parse(storedItems);
                                

                                    if( parsedItems.find (item => item.storedDiscount === $(".extra-p").val()) ){
                                        return false;
                                    }
                                    parsedItems.push(newItem);
                                    localStorage.setItem('storedItems', JSON.stringify(parsedItems));
                                
                            } else {
                                localStorage.setItem('storedItems', JSON.stringify([newItem]));
                            }
                        },
                        error: function (err) {
                            console.log(err)
                        }
                    });
                
            }, 500)
        }else{
          console.log("no extra-p");
        }
    });
    //Hide Quantity inside Cart at the beginning
    $('.cart__items__quantity').css('visibility', 'visible')
    hideQuantity()

    // Desktop Cart Button on click
    $('.navlink--cart').on('click', function () {
        $('.cart__items__quantity').css('visibility', 'visible')
        loadForm();
    })
    // after item added to cart click the button 'view cart' in Popup
    $(document).on('click', '#popdown-view-cart', function () {
        $('.cart__items__quantity').css('visibility', 'visible')
        loadForm();
    })
    // Mobile Cart Button on click
    $(document).on('click', '.header__mobile__button', function () {
        $('.cart__items__quantity').css('visibility', 'visible')
        loadForm();
    });
    //Quantity on change in cart
    $(document).on('click', 'div[data-line-items] .quantity__button', function () {
        // console.log('quantity__button');
        showLoading()
        const quan = $(this).attr('data-quantity');
        const parent = $(this).attr('data-product');
         const storedItems = localStorage.getItem('storedItems');
                const parsedItems = JSON.parse(storedItems);
        console.log("-> parent tt tt tt tt tt tt tt", parent);
        if ($(this).hasClass("quantity__button--minus")) {
            // console.log("decrease");
            const child = $(this).attr('data-child');
            
            if ((quan - 1) === 0) {
                

                // console.log("-> child", child);
                // console.log("-> parent", parent);
                if (child !== '' && child !== undefined) {
                    
                    setTimeout(function () {
                        removeItem(parent,"norefresh")
                        setTimeout(function () {
                            const items = parsedItems.filter(item => item.storedFreeItem === child).length;
                    if (items > 1) {
                        console.log("child not removed",items)
                        updateQuantity(child,"decrease",2)
                    } else {
                            removeItem(child)
                            if(parsedItems.length !== 0 && parsedItems !== null){
                const newItems = parsedItems.filter(item => item.relatedProduct !== parent.split(':')[0]);
                 localStorage.setItem('storedItems', JSON.stringify(newItems));
                }
                    }
                        }, 450)
                    }, 450)
                }else{
                    
                     removeItem(parent)
                    
                   
                }
            }else{
                
                updateQuantity(parent,"decrease", Number(quan))
            }

        } else if ($(this).hasClass("quantity__button--plus")) {
            updateQuantity(parent,"increase", Number(quan))
        }
    });

    /* $(document).on('click', '#check', function (event) {
        event.preventDefault();
        const addedGift = localStorage.getItem("storedFreeItem");
        if(addedGift){
            const child = document.querySelector(`.p-item-${addedGift}`);
            console.log("childddddddddddd",child)
            if(child){
                document.getElementById("myform").submit();
            } else {
                if (confirm("Ödeme yapmak istediğinize emin misiniz?")) {
                    document.getElementById("myform").submit();
                } else {
                    return false;
                }
            }
        } else {
            document.getElementById("myform").submit();
        }
    }); */

    $(document).on("click", ".refresh-page", function () {
        loadForm();
    })
    //DRAWER MENU Cart Input number on change
    //Cart Input number on change
    $(document).on('input', 'div[data-line-items] .quantity__input', function () {
        showLoading()
        let vl = Number($(this).val());
        const parent = $(this).attr('data-product');
        if (vl === 0) {
            const child = $(this).attr('data-child');

            if (child !== '' && child !== undefined) {
                setTimeout(function () {
                    removeItem(child)
                    setTimeout(function () {
                        removeItem(parent,"norefresh")
                    }, 450)
                }, 450)
            } else {
                removeItem(parent)
            }
        } else {
            updateQuantity(parent,"change",vl)
        }
    });
    //DRAWER MENU REMOVE ITEM BUTTON
    //Cart REMOVE Button
    $(document).on('click', '.cart__items__remove', function () {
        showLoading()
        let toolbar = $(this).parent('.cart__items__grid').parent('.cart__items__row').find('.item--loadbar');
        toolbar.show()
        setTimeout(function () {
            toolbar.hide()
        }, 3000)
        // console.log("-> cart cart__items__remove");
        const child = $(this).attr('data-child');
        const parent = $(this).attr('data-product');
        console.log("-> child", child);
        if (child !== '' && child !== undefined) {
             const storedItems = localStorage.getItem('storedItems');
                const parsedItems = JSON.parse(storedItems);
            setTimeout(function () {
                console.log("parent",parent)
                removeItem(parent,"norefresh")
                //find in stored items and remove the item and store rest
               
                if(parsedItems.length !== 0 && parsedItems !== null){
                const newItems = parsedItems.filter(item => item.relatedProduct !== parent.split(':')[0]);
                 localStorage.setItem('storedItems', JSON.stringify(newItems));
                }
               

              
                 

                setTimeout(function () {
                    const items = parsedItems.filter(item => item.storedFreeItem === child).length;
                    if (items > 1) {
                        console.log("child not removed",items)
                        updateQuantity(child,"decrease",2)
                    } else {
                        removeItem(child)
                    }
                    
                }, 450)
            }, 450)
        } else {
            removeItem(parent)
            loadForm();
            hideQuantity()
        }

    });
    //DRAWER MENU MINUS BUTTON
    /* $(document).on('click', '.quantity__button--minus', function () {
         const quan = $(this).attr('data-quantity');
         console.log(quan)
         if ((quan - 1) === 0) {

             const child = $(this).attr('data-child');
             console.log(child)
             if (child !== '' && child !== undefined) {
                 console.log(child)
                 setTimeout(function () {
                     removeItem(child)
                 }, 500)
             }
         }
     });*/
})